import { type ReactNode } from "react";
import { cn } from "@strivelabs/ui-core";
import { Upload } from "lucide-react";

/** Greeting slot rendered above the composer (home surface). */
export const ComposerGreeting = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => <div className={cn("mb-[30px] w-full", className)}>{children}</div>;

/** Drag-and-drop overlay shown while files are dragged over the composer. */
export const ComposerDropOverlay = ({
  active,
  hint,
}: {
  active: boolean;
  /** Optional caption under the label, such as the file count and size limits. */
  hint?: ReactNode;
}) => {
  if (!active) return null;
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -inset-1 z-50 flex flex-col items-center justify-center gap-2.5 rounded-xl border-2 border-dashed border-border bg-background/75 backdrop-blur-[2px]"
    >
      <div className="flex size-11 items-center justify-center rounded-lg border bg-background shadow-sm">
        <Upload className="size-5 text-muted-foreground" />
      </div>
      <div className="text-sm font-medium text-foreground">
        Drop to attach files or images
      </div>
      {hint && <div className="text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
};
